import 'antd/dist/antd.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './main.css'
import { AnalyticsProvider } from '@/context/analytics-context'
import { LocalStorageProvider } from '@/context/localstorage-context'

import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LocalStorageProvider>
      <AnalyticsProvider
        config={{
          measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID ?? '',
          enabled: import.meta.env.VITE_GA_ENABLED === 'true',
          debug: import.meta.env.VITE_GA_DEBUG === 'true',
          sendPageView: false,
        }}
      >
        <App />
      </AnalyticsProvider>
    </LocalStorageProvider>
  </StrictMode>,
)
